import { InvokeCallback, Sender } from "xstate";
import { CreateMultipleBookingParams } from "@rentablo/api/apiv1";
import { DividendWizardContext } from "../types/dividendWizardContext";
import { DividendWizardEvent } from "../types/dividendWizardEvent";
import { buildCreateOrUpdateBookingParams } from "../../utils/utils";
import { checkBookingConsistency } from "../../utils/checkBookingConsistency";

export const validateSingleBooking =
  (
    context: DividendWizardContext,
    event: DividendWizardEvent
  ): InvokeCallback<DividendWizardEvent, DividendWizardEvent> =>
  (callback) => {
    if (event.type !== "DIVIDEND_FILLED") {
      throw new Error(`Invalid event type ${event.type}`);
    }

    if (!context.bookingId) {
      throw new Error(`Invalid booking id: ${context.bookingId}`);
    }

    if (!context.investment?.id || !context.investment.account.id) {
      throw new Error(`Invalid investment id: ${context.investment?.id}`);
    }

    const params = buildCreateOrUpdateBookingParams(
      context.investment.id,
      context.dividendValues,
      context.investment.account.id,
      context.bookingId
    );

    validate(params, callback);
  };

const validate = async (
  params: CreateMultipleBookingParams,
  callback: Sender<DividendWizardEvent>
) => {
  try {
    const { hasValidationErrors, transactionValidationErrors } =
      await checkBookingConsistency(params);

    if (!hasValidationErrors) {
      callback({
        type: "DIVIDENDS_VALIDATED",
        validatedMultipleBookingParams: params,
      });

      return;
    }

    callback({ type: "BACK", validationErrors: transactionValidationErrors });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
